module.exports = [
  function() {
    var apiConfig = {
      server: "",

      $get: [
        "backend.config",
        "backend.Timesheet",
        "backend.Approval",
        "backend.News",
        "backend.Projects",
        "backend.AppConfig",
        "backend.Content",
        "backend.Payroll",
        "backend.Leave",
        function(
          backend,
          Timesheet,
          Approval,
          News,
          Projects,
          AppConfig,
          Content,
          Payroll,
          Leave
        ) {
          return {
            Login: {
              // login: function (credentials) {
              //   return backend.login(credentials);
              // },
              logout: function() {
                return backend.logout();
              },
              status: function() {
                return !!backend.token;
              }
              // get token () {
              //   return backend.token;
              // },
              // set token (value) {
              //   backend.token = value;
              // },
              // get credentials () {
              //   return backend.credentials;
              // }
            },
            Timesheet: Timesheet,
            Timesheets: Timesheet,
            Approval: Approval,
            News: News,
            Projects: Projects,
            Content: Content,
            Payroll: Payroll,
            Leave: Leave,
            AppConfig: AppConfig
          };
        }
      ]
    };

    return apiConfig;
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/api.js